import {
    AfdelingForloebKladdeResponseModel
} from "../../../services/api/forloeb/uddannelsesstedForloebKladderResponseModel";
import {StillingForloebKladderOverviewModel} from "./stillingForloebKladderOverviewModel";

export class AfdelingStillingForloebKladderModel {

    public static FromResponseModel(responseModel: AfdelingForloebKladdeResponseModel): AfdelingStillingForloebKladderModel {
        const model = new AfdelingStillingForloebKladderModel();
        model.afdelingId = responseModel.afdelingId;
        model.laegeinstitutionId = responseModel.laegeinstitutionId;
        model.afdelingNavn = responseModel.afdelingNavn;
        model.afdelingStillingForloebKladder = responseModel.stillingerWithForloebKladder.map(l => StillingForloebKladderOverviewModel.FromResponseModel(l));
        return model;
    }

    afdelingId: string;
    laegeinstitutionId: string;
    afdelingNavn: string;
    afdelingStillingForloebKladder: StillingForloebKladderOverviewModel[];
}
